export default __webpack_public_path__ + "static/media/bag4.af0b062c.jpg";